import React from 'react';

import { RESTING_TEMPERATURE_C } from './pulseModel.js';

const TemperatureReadout = () => (
  <div className="monitor-temperature">
    <span>TEMP</span>
    <span id="temperature-value">{RESTING_TEMPERATURE_C.toFixed(1)}</span>
    <span>°C</span>
  </div>
);

export default TemperatureReadout;
